<template>
  <div class="view" ref="startLink">
    <nav @click="scrollToComponent">
      <img @click="scrollToTop(startLink)" class="logo-image" src="@/assets/gi-logo-image.png" draggable="false">
      <ul class="influencer-navigation">
        <a class="headers" href="#about" >About G.IO</a>
        <a class="headers" href="#platform">Platform Services</a>
        <a class="headers" href="#testimonials">Testimonials</a>
        <a class="headers" href="#faq">FAQ</a>
        <button class="switch-btn" @click="$router.push({ name: 'brand-view' })">Switch To Brand View</button>
        <button class="login-button" @click="$router.push({ name: 'login'})">Login  / Register</button>
      </ul>
      <span @click="op = true" v-if="isMobile" class="material-icons menu-mobile">menu</span>

      <sidebar-view v-if="isMobile" @close="closeSidebar" :op="op" :view="'creator'"/>
    </nav>

    <landing-header :view="'creator'" :currentCampaign="currentCampaign" />

    <div style="background-color: #130a23;">
      <sponsors-row :is-mobile="isMobile" />
    </div>

    <div id="about" ref="about" class="about">
      <what-is-gio :view="'creator'" :is-mobile="isMobile" />
    </div>

    <platform-services :is-mobile="isMobile" :view="'creator'"/>

    <div id="testimonials" ref="testimonials" class="testimonials">
      <div style="margin: 0 auto;max-width: 1600px;">
        <div class="p-d-flex p-justify-between influencer-say-row" v-if="!isMobile">
          <div>
            <div class="testimonials-title">What do other influencers say?</div>
            <div class="p-d-flex">
              <span class="material-icons quote">format_quote</span>
              <div class="p-ml-2">
                <div class="p-d-flex">
                  <div class="influencer-name">Anime Balls Deep</div>
                  <div class="star-margin-left">
                    <span class="material-icons star">star</span>
                    <span class="material-icons star">star</span>
                    <span class="material-icons star">star</span>
                    <span class="material-icons star">star</span>
                    <span class="material-icons star">star</span>
                  </div>
                </div>
                <div class="yt-influencers">Youtube influencers</div>
              </div>
            </div>
            <div class="influencer-text">We're always looking for new ways to monetize our content,
              and G.IO made it incredibly easy to do just that. It's great!
            </div>
            <button class="join-btn" @click="$router.push({ name: 'login'})"> JOIN NOW</button>
          </div>
          <div class="testimonials-adjust">
            <img src="../assets/landing/Influencer-image-1.png" class="testimonials-image" alt="influencer avatar"
                 draggable="false">
            <img src="../assets/landing/Influencer-image-2.png" class="testimonials-image" alt="influencer avatar"
                 draggable="false">
            <img src="../assets/landing/Influencer-image-3.png" class="testimonials-image" alt="influencer avatar"
                 draggable="false">
            <img src="../assets/landing/Influencer-image-4.png" class="testimonials-image" alt="influencer avatar"
                 draggable="false">
            <img src="../assets/landing/Influencer-image-5.png" class="testimonials-image" alt="influencer avatar"
                 draggable="false">
            <img src="../assets/landing/Influencer-image-6.png" class="testimonials-image" alt="influencer avatar"
                 draggable="false">
          </div>
        </div>
        <div v-else>
          <div class="p-flex-column" style="text-align: center">
            <div class="testimonials-title-mobile">What do other influencers say?</div>
            <div class="p-d-flex p-jc-center p-mt-6 box-start">
              <div>
                <img src="../assets/anime-balls.png" draggable="false"/>
              </div>
              <div class="p-flex-column column-deep-mobile">
                <div class="influencer-name p-ml-4">Anime Balls Deep</div>
                <div class="p-mt-2 yt-influencers">Youtube influencers</div>
                <div class="p-mt-4 stars-row">
                  <span class="material-icons star">star</span>
                  <span class="material-icons star">star</span>
                  <span class="material-icons star">star</span>
                  <span class="material-icons star">star</span>
                  <span class="material-icons star">star</span>
                </div>
              </div>
            </div>
            <div class="influencer-text-mobile">We're always looking for new ways to monetize our content,
              and G.IO made it incredibly easy to do just that. It's great!
            </div>
            <button class="join-btn" @click="$router.push({ name: 'login'})"> JOIN NOW</button>
          </div>
        </div>
      </div>
    </div>

    <div class="container-discord">
      <div class="p-d-flex discord-adjust margin-discord" id="discord" ref="discord">
        <div class="p-d-flex p-ai-center" style="gap: 15px" @click="discord">
          <span class="material-icons discord-image">discord</span>
          <div class="discord-text">Join our Discord server to learn more, get updates,
            and connect with other influencers!
          </div>
        </div>
      </div>
    </div>

    <div class="faq">
      <faq-updated ref="faq" id="faq"/>
    </div>

    <landing-footer :view="'creator'" :is-mobile="isMobile"/>
  </div>
</template>

<script>
import FaqUpdated from './home/faqUpdated.vue';
import LandingHeader from './home/LandingHeader.vue';
import LandingFooter from './home/LandingFooter.vue';
import SidebarView from './home/SidebarView.vue';
import PlatformServices from './home/PlatformServices.vue';
import WhatIsGio from './home/WhatIsGio.vue';
import SponsorsRow from './home/SponsorsRow.vue';
import { scrollToComponent, discord, scrollToTop } from './home/utils';
import { ref } from 'vue';

export default {
  components: {
    FaqUpdated,
    LandingHeader,
    LandingFooter,
    SidebarView,
    WhatIsGio,
    PlatformServices,
    SponsorsRow,
  },
  setup() {
    const op = ref(false);
    const startLink = ref();

    const closeSidebar = () => {
      op.value = !op.value;
    };

    const currentCampaign = {
      name: "RAID: Shadow Legends",
      amount: 21,
      logoPath: "raid-logo.png" // not in use currently
    };

    return {
      currentCampaign,
      op,
      startLink,
      closeSidebar,
      scrollToComponent,
      discord,
      scrollToTop,
    };
  },
  data() {
    return {
      about: null,
      platform: null,
      testimonials: null,
      faq: null,
      isMobile: false,
    };
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped lang="scss">
.view {
  max-width: 100%;
  width: 100%;
  overflow: hidden;
}

.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  /* Preferred icon size */
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: 'liga';
}

* {
  font-family: 'Montserrat', sans-serif;
}

.about {
  background-color: #130a23;
}

.margin-discord {
  padding: 66px 30px;
}
nav ul {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

nav a {
  color: #fff;
  text-decoration: none;
}

.faq {
  padding: 40px 30px;
  background: #130A23;
}

.testimonials {
  height: auto;
  background-color: #130A23;
  padding: 120px 60px;
}

.container {
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 30px;
}

.logo-image {
  width: 8%;
  height: 90%;
  margin-left: 5%;
  cursor: pointer;
}

nav {
  background-color: #130a23;
  display: flex;
  align-items: center;
  padding: 0 20px;
  z-index: 999;
  min-height: 90px;
  position: fixed;
  width: 100%;
}

ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

li {
  margin: 10px 50px;
  font-size: 16px;
}

a {
  color: #fff;
  text-decoration: none;
  transition: color 0.2s;
}

a:hover {
  color:#E73D38;
}

.box-start {
  height: 120px;
}

.influencer-navigation {
  justify-content: space-between;
  padding-right: 5%;
  padding-left: 5%;
  gap: 10px;
  align-items: center;
}

.email-message {
  font-size: 12rem;
  line-height: 14.63px;
}

.quote {
  color: #FFFFFF;
  background-color: #E6343C;
  border-radius: 45px;
  font-size: 44px;
  width: 45rem;
  height: 45rem;
}

.influencer-name {
  font-size: 24rem;
  line-height: 29rem;
  font-weight: 700;
  color: #FFFFFF;
}

.star {
  color: #FFFFFF;
  font-size: 26px;
  margin-left: 7px;
  margin-top: -5px;
}
.star-margin-left {
  padding-left: 42rem;
  display: flex;
  align-items: center;
}

.influencer-text {
  font-weight: 400;
  font-style: italic;
  font-size: 16px;
  line-height: 19px;
  width: 500px;
  padding-top: 5%;
  color: #FFFFFF;
}

.influencer-text-mobile {
  font-weight: 400;
  font-style: italic;
  font-size: 14px;
  line-height: 19px;
  padding-top: 3%;
  width: 50%;
  margin-left: 25%;
  color: #FFFFFF;
}

.join-btn {
  margin-top: 70px;
}

.testimonials-title {
  font-size: 36px;
  line-height: 44px;
  color: #FFFFFF;
  padding-bottom: 15%;
  font-weight: 700;
}
.testimonials-title-mobile {
  font-size: 28px;
  line-height: 28px;
  color: #FFFFFF;
  font-weight: 700;
  padding-top: 10%
}

.testimonials-image {
  max-height: 115px;
  max-width: 115px;
  width: 100%;
  height: 100%;
}

.discord-image {
  color: #FFFF;
  background: #8C9EFF;
  font-size: 60px;
  border-radius: 50%;
  padding: 0.5%;
  cursor: pointer;
  width: auto;
  height: max-content;
}

.discord-text {
  font-weight: 700;
  font-size: 36px;
  line-height: 43.88px;
  color: #FFFFFF;
  margin-left: 2%;
  cursor: pointer;
}
.discord-text:hover {
  text-decoration: underline;
}

.east-button {
  background: #FFFFFF;
  color: red;
  border: none;
  padding: 5px;
  margin-left: -5px;
  height: 41px !important;
  width: 100%;
  max-width: 40px;
  border-radius: 0px 10px 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.headers {
  font-weight: 700;
  font-size: 18rem;
  line-height: 35.5px;
}

::placeholder {
  color: #C2BBBB;
}

@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange; }
}

.testimonials-adjust {
  display: flex;
  flex-wrap: wrap;
  max-width: 486px;
  gap: 35px 70px;
  align-self: end;
}

.discord-adjust {
  height: 100%;
  max-height: 220px;
  overflow: hidden;
  max-width: 1600px;
  margin: 0 auto;
}

.container-discord {
  background-color: #E6443C;
}

.gi-gmbh {
  font-weight: 400;
  font-size: 16rem;
  line-height: 19.5px;
}

.east-button:hover {
  background: #E6443C;
  color: #FFFFFF;
}

.menu-mobile {
  font-size: 50rem;
  color: #FFFFFF;
  margin-left: auto;
  padding-right: 5%;
}
.gap-sponsors-3 {
  gap: 10%;
}
.gap-sponsors-2 {
  gap: 15%;
}
.yt-influencers {
  color: white;
}
@media screen and (max-width: 1100px) {
  ul {
    width: 80%;
  }
}

@media screen and (max-width: 1280px) {
  .headers {
    font-size: 14rem;
  }
  ul {
    width: 80%;
  }
  .margin-discord {
    padding: 66px 60px;
  }
  .influencer-navigation {
    padding-right: 0px;
  }
}

@media screen and (max-width: 1200px) {
  .discord-text {
    font-size: 28px;
    line-height: 40.88px;
  }
}

@media screen and (max-width: 1024px) {
  .influencer-navigation {
    padding-left: 3%;
    padding-right: 3%;
  }
  li {
    font-size: 10px;
  }
  .testimonials-title {
    font-size: 30px;
    line-height: 30px;
  }
  .discord-text {
    font-size: 26px;
    line-height: 36.88px;
  }
  .headers {
    font-size: 12rem;
  }
}

.column-deep-mobile {
  height: 100%;
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 768px) {
  .influencer-name {
    font-size: 17rem;
    line-height: 17rem;
  }
  .influencer-navigation {
    display: none;
  }
  .logo-image {
    width: 16%;
  }
  .testimonials {
    padding: 40px 30px;
  }
  .discord-text {
    font-size: 17px;
    line-height: 35.88px;
  }
  .join-btn {
    margin: 10% auto;
  }
  .influencer-text-mobile {
    margin: 0 auto;
    width: 100%;
  }
  .star {
    width: 24px;
  }
  .yt-influencers {
    margin-top: -5px !important;
    line-height: 30px;
  }
  .stars-row {
    margin-top: -0px !important;
    margin-bottom: -7px;
  }
  .margin-discord {
    padding: 46px 30px;
  }
  .faq {
    padding: 40px 0px;
  }
}
@media screen and (max-width: 578px) {
  .gap-sponsors-3 {
    gap: 4%;
    scale: 0.8;
  }
  .logo-image {
    width: 90rem;
    height: 46rem;
    margin-left: 5%;
  }
  .gap-sponsors-2 {
    gap: 8%;
    scale: 0.8;
  }
  .gi-gmbh {
    scale: 0.8;
  }
  .discord-text {
    line-height: 25.88px;
  }
  .testimonials {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .testimonials-title-mobile {
    padding-top: 0px;
  }
  .testimonials {
    img {
      max-width: 60px;
    }
  }
  .box-start {
    max-height: 60px;
  }
}

@media screen and (max-width: 412px) {
  .gap-sponsors-3 {
    gap: 4%;
    scale: 0.6;
  }
  .gap-sponsors-2 {
    gap: 8%;
    scale: 0.6;
  }
  .discord-image {
    font-size: 35px;
    padding: 5px;
  }
  .discord-text {
    font-size: 14px;
    line-height: 17px;
  }
}

@media screen and (min-width: 2200px) {
  nav {
    .headers {
      font-size: 30rem;
    }
  }
}

@media screen and (min-width: 1600px) {
  .influencer-say-row {
    padding: 0px 30px;
  }
}
</style>
